<div class="d-flex main-file-box" *ngFor="let file of files">
    <div class="file-box d-flex">
      <div class="d-flex">
        <ng-container [ngSwitch]="getFileType(file.url)">
          <div class="myClass" *ngSwitchCase="'image'">
            <img [src]="file.url" />
          </div>
          <div class="file-icon" *ngSwitchCase="'video'">
            <video controls>
              <source [src]="file.url" type="video/mp4" />
            </video>
          </div>
          <div class="file-icon" *ngSwitchCase="'audio'">
            <audio controls>
              <source [src]="file.url" />
            </audio>
          </div>
          <ng-container class="file-icon" *ngSwitchDefault>
            <div class="file-icon">
              <nb-icon icon="file-text-outline"></nb-icon>
            </div>
            <div class="file-info">
              <div class="file-name">{{file.fileName}}</div>
            </div>
          </ng-container>
        </ng-container>
        
      </div>
      <div class="file-download">
        <a [href]="file.url" target="_blank" download>
          <nb-icon icon="download-outline"></nb-icon>
        </a>
      </div>
    </div>
    </div>